// *****************************************************************************
// Description Module
// *****************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const descriptionModule = document.querySelector('.description-module');
  if (!descriptionModule) return;

  const descriptionImages = document.querySelectorAll('.description-module__image');
  const getRandomDuration = (min, max) => Math.random() * (max - min) + min;

  if (descriptionImages.length) {
    const controller = new ScrollMagic.Controller();
    descriptionImages.forEach((image, index) => {
      const parent = image.closest('.description-module__image-list');
      image.style.transitionDuration = `${getRandomDuration(0.6, 1.2)}s`;

      const moveY = [1, 2, 3].includes(index) ? '20%' : '-40%';
      const heroAnimationTween = gsap.to(image, { y: moveY, ease: 'none', paused: true });

      new ScrollMagic.Scene({
        triggerElement: parent,
        triggerHook: 0.8,
        duration: '100%',
      })
        .setTween(heroAnimationTween)
        .addTo(controller);
    });
  }
});
